qtee.customDesign = window.qtee.customDesign || {};

/** Add to cart view */
qtee.customDesign.AddToCartView = Backbone.Marionette.ItemView.extend({
	template: '/custom-design/templates/add-to-cart',
	modelEvents: {
		change: 'render'
	},
	ui: {
		size: '.oneSize',
		addToBag: '.addToBag',
		checkout: '.checkout',
		qty: '.qty',
		loadingOverlay: '.loadingOverlay2'
	},
	events: {
		'click @ui.addToBag': 'addToBagClick',
		'click @ui.checkout': 'checkoutClick',
		'click @ui.size:not(.disabled)': 'sizeClick',
		'input @ui.qty': 'qtyInput'
	},
	templateHelpers () {

		const that = this;
		return {
			availableSizes () {

				const sizes = _.findWhere(that.model.get('AvailableProductColors'), { IsSelected: true });
				if (sizes && sizes.AvailableSizes) {

					return _.where(sizes.AvailableSizes, { IsAvailable: true });

				}
				return [];

			}
		};

	},
	initialize (opts) {

		this.customProdModel = opts.customProdModel;

	},
	qtyInput () {

		let val = this.ui.qty.val().replace(/[^0-9]/g, '');
		if (parseInt(val) == 0) {

			val = 1;

		}
		this.ui.qty.val(val);

	},
	sizeClick (e) {

		const $e = $(e.currentTarget);
		const newSize = $e.data('size');
		const sizes = _.findWhere(this.model.get('AvailableProductColors'), { IsSelected: true });

		// update UI
		this.ui.size.removeClass('active');
		$e.addClass('active');

		// update model
		if (sizes && sizes.AvailableSizes) {

			_.where(sizes.AvailableSizes, { IsSelected: true }).forEach((s) => {

				s.IsSelected = false;

			});
			_.findWhere(sizes.AvailableSizes, { Size: newSize }).IsSelected = true;

		}

	},
	/**
	 * Get data that needs to add to bag
	 * @param  {Function} callback invoked when data is ready
	 */
	_getDataForAddToBag (callback) {

		let sizes;
		let qty;
		let token;
		let sku;

		// get available sizes
		sizes = _.findWhere(this.model.get('AvailableProductColors'), { IsSelected: true });

		// get sku
		if (sizes && sizes.AvailableSizes) {

			sku = _.findWhere(sizes.AvailableSizes, { IsSelected: true }).ShortSku;

		} else {

			throw "There're no available sizes";

		}

		// get qty
		qty = parseInt(this.ui.qty.val(), 10) || 1;
		this.ui.qty.val(qty);

		// if model is not updated on server then create clone on server and use token from this new model
		if (Backbone.customDesign.isEmulateOn()) {

			const model = this.customProdModel.clone();
			Backbone.customDesign.stopEmulateAjax();
			model.save(
				{},
				{
					cloneBySprites: true,
					success: (r) => {

						callback(sku, qty, model.get('Token'));

					},
					error: (r) => {
						// TODO: error handler
					}
				}
			);
			Backbone.customDesign.startEmulateAjax();

		} else {

			callback(sku, qty, this.customProdModel.get('Token'));

		}

	},
	/**
	 * Add to bag
	 * @param {function} success callback
	 * @param {function} error   callback
	 * @param {function} complete callback
	 */
	addToBag (success, error, complete) {

		this._getDataForAddToBag((sku, qty, token) => {

			qtee.customDesign.utils.addToBag(sku, qty, token).done(success).fail(error).always(complete);

		});

	},
	checkoutClick () {

		const stopLoader = window.lp.utils.customDesign.delayLoading(
			this.ui.loadingOverlay,
			qtee.customDesign.settings.loaderThreshold
		);
		this.addToBag(
			() => {

				const proto = 'https://';
				const host = `${window.location.hostname}`;
				const port = window.location.port !== '80' ? `:${window.location.port}` : '';
				const url = proto + host + port;

				window.location = `${url}/cart`;

			},
			() => {
				// TODO: actual error handler
			}
		);

	},
	addToBagClick () {

		const stopLoader = window.lp.utils.customDesign.delayLoading(
			this.ui.loadingOverlay,
			qtee.customDesign.settings.loaderThreshold
		);
		this.addToBag(
			() => {

				$('body').lpModalClose();

			},
			() => {
				// TODO: actual error handler
			},
			stopLoader
		);

	}
});
